var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowerRoomPoi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3,
    fill: "#0000FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 18C19.5 16.0109 20.2902 14.1032 21.6967 12.6967C23.1032 11.2902 25.0109 10.5 27 10.5C28.9891 10.5 30.8968 11.2902 32.3033 12.6967C33.7098 14.1032 34.5 16.0109 34.5 18V37.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1216 25.122H15.8736C15.4975 25.1221 15.1267 25.0328 14.7918 24.8614C14.457 24.69 14.1677 24.4415 13.9478 24.1363C13.7279 23.8311 13.5837 23.478 13.527 23.1062C13.4704 22.7343 13.503 22.3543 13.6221 21.9975C14.0096 20.8333 14.7538 19.8206 15.7492 19.103C16.7446 18.3855 17.9406 17.9996 19.1676 18H19.8276C21.0546 17.9998 22.2505 18.3858 23.2459 19.1033C24.2412 19.8208 24.9855 20.8334 25.3731 21.9975C25.4923 22.3543 25.5249 22.7343 25.4682 23.1062C25.4116 23.478 25.2674 23.8311 25.0475 24.1363C24.8276 24.4415 24.5383 24.69 24.2034 24.8614C23.8686 25.0328 23.4978 25.1221 23.1216 25.122Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 36V37.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 31.5V30",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4969 35.4755L27.6719 34.2305",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3594 29.25L25.1844 30.495",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6375 29.25L13.8125 30.495",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.325 34.2305L10.5 35.4755",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowerRoomPoi);
export default __webpack_public_path__ + "static/media/shower-room-poi.60ad9e4466dcf8c94078e2ded848cdee.svg";
export { ForwardRef as ReactComponent };